import React from 'react'
import { fromUnixTime, format } from 'date-fns'
import { Link, TCell, TRow } from '@elsevier/graphene'

interface JobInformation {
  requestDateTime: number
  jobUrl: string
  status: string
  fileName: string
}

export default function JobListing({
  jobUrl,
  requestDateTime,
  status,
  fileName,
}: JobInformation) {
  return (
    <TRow>
      <TCell>
        {jobUrl ? (
          <Link
            data-feature="job-download-link"
            label={fileName}
            href={jobUrl}
          />
        ) : (
          fileName
        )}
      </TCell>
      <TCell>{format(fromUnixTime(requestDateTime), 'MM-dd-yyyy h:mm')}</TCell>
      <TCell>{status}</TCell>
    </TRow>
  )
}
